(function($, duo, undefined) {

	"use strict";

	/**
	 * Class MediaQuery
	 */
	class MediaQuery {

		/**
		 * Gets the current media query
		 * @param {string} selector html element
		 * @param {string} pseudoElement pseudo element
		 * @return {string} media query string
		 */
		static getMediaQuery(selector = 'body', pseudoElement = ':before') {
			var element = document.querySelector(selector);
			var mediaQuery = window.getComputedStyle(element, pseudoElement).getPropertyValue('content'); 
			return mediaQuery.replace(/["']/g, "");
		}
	}

	duo.MediaQuery = MediaQuery;

})(jQuery, window.duo = window.duo || {});
